import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { catchError, exhaustMap, Observable, of } from 'rxjs';

import { ApiResponse } from '@interfaces/api-response';

import { BASE_PATH } from '@generated/content';
import { environment } from '../../../environments/environment';
import { LanguageService } from '@services/language/language.service';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private readonly basePath: string;

  constructor(@Inject(BASE_PATH) @Optional() basePath: string, private http: HttpClient) {
    this.basePath = basePath || [environment.apiHost, LanguageService.selectedLanguage, 'jsonapi'].join('/');
  }

  public get<T>(path: string, params?: { [key: string]: string | number }, url?: string): Observable<ApiResponse<T>> {
    if (!url) {
      path = path.startsWith('/') ? path.slice(1) : path;
      url = `${this.basePath}/${path}`;
    }

    return this.http.get<T>(url.toLowerCase(), { params, responseType: 'json' }).pipe(
      exhaustMap(payload => of({ payload })),
      catchError((error: HttpErrorResponse) => of({ payload: null, error }))
    );
  }
}
